import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import classNames from 'classnames/bind';

import {
  DataBlocks,
  Preloader,
  I18n,
  Status,
} from 'components';

import { formatDate } from 'utils/formatString';

import { toggleExpensesFilter } from '../../actions';

import { EXPENSES_SECTIONS } from '../../constants';

import ExpensesTabs from '../../components/ExpensesTabs';

import styles from './styles.pcss';

const cx = classNames.bind(styles);

class Expenses extends Component {
  constructor(props) {
    super(props);

    this.state = {
      activeTab: EXPENSES_SECTIONS.STRUCTURE,
    };
  }

  setActiveTab = (tab) => {
    this.setState({ activeTab: tab });
  };

  render() {
    const {
      filters,
      structure,
      callDetails,
      period,
      currency,
      actions,
      error,
      isFetching,
    } = this.props;

    const { activeTab } = this.state;

    if (isFetching) {
      return <Preloader className={cx('preloader')} size="80" />;
    }

    if (error === 'INCORRECT_PERIOD') {
      return (
        <Status className={['error', cx('status')]}>
          <I18n path="detalization.expenses.incorrectPeriod" />
        </Status>
      );
    }

    if (error === 'TOO_MANY_TRANSACTIONS') {
      return (
        <Status className={['attention', cx('status')]}>
          <I18n path="detalization.expenses.tooManyTransactions" />
        </Status>
      );
    }

    if (error === 'SERVER_ERROR') {
      return (
        <Status className={['attention', cx('status')]}>
          <I18n path="detalization.expenses.errorMessage" />
        </Status>
      );
    }

    if (!callDetails) {
      return (
        <Status className={['attention', cx('status')]}>
          <I18n path="detalization.expenses.emptyMessage" />
        </Status>
      );
    }

    if (!period) return null;

    return (
      <DataBlocks.ContentGroup
        title={(
          <I18n
            path={`detalization.expenses.${activeTab}Title`}
            vars={{ start: formatDate(period.start), end: formatDate(period.end) }}
          />
        )}
      >
        <ExpensesTabs
          currency={currency}
          filters={filters}
          details={callDetails}
          spendingStructure={structure}
          toggleFilter={actions.toggleExpensesFilter}
          onChangeActiveTab={this.setActiveTab}
        />
      </DataBlocks.ContentGroup>
    );
  }
}

function mapStateToProps(state) {
  return state.detalization.expenses;
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({
      toggleExpensesFilter,
    }, dispatch),
  };
}

Expenses.defaultProps = {
  currency: 'RUR',
};

Expenses.propTypes = {
  filters: PropTypes.array,
  structure: PropTypes.array,
  callDetails: PropTypes.array,
  period: PropTypes.object,
  currency: PropTypes.string,
  actions: PropTypes.object,
  error: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  isFetching: PropTypes.bool,
};

export default connect(mapStateToProps, mapDispatchToProps)(Expenses);
